/**
 * Pre-results driver preference wizard (modal on tire finder).
 */
(function (global) {
  var RESULTS_PAGE = "/pages/tire-results";
  var SEARCH_CONTEXT_KEY = "specr_tire_search_context";
  var SEARCH_PARAM_KEYS = ["size", "vin", "year", "make", "model", "trim", "vehicleId"];

  var wizardEl = null;
  var summaryEl = null;
  var titleEl = null;
  var progressEl = null;
  var stepHost = null;
  var backBtn = null;
  var nextBtn = null;
  var skipBtn = null;
  var closeBtns = null;
  var inited = false;

  var pendingSearchQuery = "";
  var pendingSummary = "";
  var stepIndex = 0;
  var state = { goal: "", driving: "mixed", priority: "" };
  var lastFocus = null;
  var bodyScrollLock = "";

  function getSteps() {
    return (global.SpecrTireProfile && global.SpecrTireProfile.WIZARD_STEPS) || [];
  }

  function normalizeQs(qs) {
    if (!qs) return "";
    return qs.indexOf("?") === 0 ? qs : "?" + String(qs).replace(/^\?/, "");
  }

  function lockBody() {
    bodyScrollLock = document.body.style.overflow;
    document.body.style.overflow = "hidden";
  }

  function unlockBody() {
    document.body.style.overflow = bodyScrollLock || "";
  }

  function setHubStepper(activeStep) {
    var hub = document.getElementById("tire-finder");
    if (!hub) return;
    var items = hub.querySelectorAll(".tf-stepper__item[data-tf-step]");
    if (!items.length) return;
    items.forEach(function (el) {
      var stepNum = parseInt(el.getAttribute("data-tf-step"), 10);
      el.classList.remove("tf-stepper__item--active", "tf-stepper__item--done");
      if (stepNum < activeStep) el.classList.add("tf-stepper__item--done");
      else if (stepNum === activeStep) el.classList.add("tf-stepper__item--active");
    });
  }

  function resetHubStepper() {
    setHubStepper(1);
  }

  function summaryFromQuery(qs) {
    var params = new URLSearchParams((qs || "").replace(/^\?/, ""));
    if (params.get("size")) {
      var parts = params.get("size").split("-");
      if (parts.length === 3) {
        return parts[0] + "/" + parts[1] + "R" + parts[2];
      }
      return params.get("size");
    }
    if (params.get("vin")) {
      var vin = params.get("vin");
      if (vin.length > 8) return "VIN ending " + vin.slice(-4);
      return "VIN " + vin;
    }
    if (params.get("vehicleId")) return "Your saved vehicle";
    var ymm = [params.get("year"), params.get("make"), params.get("model"), params.get("trim")]
      .filter(Boolean)
      .map(function (p) {
        return decodeURIComponent(p.replace(/\+/g, " "));
      });
    if (ymm.length) return ymm.join(" ");
    return "Your search";
  }

  function searchQueryFromContext(ctx) {
    if (!ctx) return "";
    var out = new URLSearchParams();
    SEARCH_PARAM_KEYS.forEach(function (key) {
      if (ctx[key]) out.set(key, ctx[key]);
    });
    var s = out.toString();
    return s ? "?" + s : "";
  }

  function buildResultsUrl(skipProfile) {
    var qs = pendingSearchQuery || "";
    if (!skipProfile && state.goal && global.SpecrTireProfile) {
      qs = global.SpecrTireProfile.appendProfileStateToQueryString(qs, state);
    }
    return RESULTS_PAGE + normalizeQs(qs);
  }

  function finish(skipProfile) {
    if (skipProfile) {
      if (global.SpecrTireProfile) global.SpecrTireProfile.clearProfile();
    } else if (state.goal && global.SpecrTireProfile) {
      global.SpecrTireProfile.writeProfile(state);
    }
    close(false);
    global.location.href = buildResultsUrl(skipProfile);
  }

  function renderStep() {
    var steps = getSteps();
    var step = steps[stepIndex];
    if (!step || !stepHost || !global.SpecrTireProfile) return;

    if (progressEl) {
      progressEl.textContent = "Step " + (stepIndex + 1) + " of " + steps.length;
    }
    if (titleEl) titleEl.textContent = step.legend;
    if (backBtn) backBtn.hidden = stepIndex === 0;
    if (nextBtn) {
      nextBtn.textContent = stepIndex === steps.length - 1 ? "See results" : "Next";
    }
    if (skipBtn) skipBtn.hidden = false;

    global.SpecrTireProfile.mountWizardStep(stepHost, step, state);
  }

  function openWizard(payload) {
    if (!wizardEl) return false;
    if (global.SpecrFinderDrawer && global.SpecrFinderDrawer.close) {
      global.SpecrFinderDrawer.close();
    }
    pendingSearchQuery = normalizeQs((payload && payload.searchQuery) || "");
    pendingSummary = (payload && payload.summary) || summaryFromQuery(pendingSearchQuery);

    var stored = global.SpecrTireProfile && global.SpecrTireProfile.readProfile();
    state = {
      goal: (stored && stored.goal) || "",
      driving: (stored && stored.driving) || "mixed",
      priority: (stored && stored.priority) || "",
    };
    stepIndex = 0;

    if (summaryEl) summaryEl.textContent = pendingSummary;
    lastFocus = document.activeElement;
    wizardEl.hidden = false;
    lockBody();
    setHubStepper(2);
    renderStep();
    var firstChip = stepHost && stepHost.querySelector(".tr-profile-chip");
    if (firstChip) firstChip.focus();
    else if (nextBtn) nextBtn.focus();
    return true;
  }

  function openWizardWithRetry(payload) {
    if (!ensureInit()) {
      scheduleOpenRetry(payload);
      return;
    }
    if (openWizard(payload)) return;
    scheduleOpenRetry(payload);
  }

  function scheduleOpenRetry(payload) {
    var tries = 0;
    function retry() {
      tries += 1;
      ensureInit();
      if (openWizard(payload)) return;
      if (tries < 30) {
        requestAnimationFrame(retry);
        return;
      }
      if (payload && payload.searchQuery) {
        global.location.href = RESULTS_PAGE + normalizeQs(payload.searchQuery);
      }
    }
    requestAnimationFrame(retry);
  }

  function close(restoreFocus) {
    if (!wizardEl) return;
    wizardEl.hidden = true;
    unlockBody();
    resetHubStepper();
    if (restoreFocus !== false && lastFocus && lastFocus.focus) {
      try {
        lastFocus.focus();
      } catch (e) {}
    }
  }

  function onNext() {
    var steps = getSteps();
    if (stepIndex < steps.length - 1) {
      stepIndex += 1;
      renderStep();
      return;
    }
    finish(false);
  }

  function getFocusableInWizard() {
    if (!wizardEl) return [];
    var panel = wizardEl.querySelector(".tfw-wizard__panel");
    if (!panel) return [];
    return Array.prototype.slice
      .call(
        panel.querySelectorAll(
          'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      )
      .filter(function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      });
  }

  function trapFocus(e) {
    if (!wizardEl || wizardEl.hidden || e.key !== "Tab") return;
    var focusable = getFocusableInWizard();
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function onEscape(e) {
    if (!wizardEl || wizardEl.hidden || e.key !== "Escape") return;
    e.preventDefault();
    if (stepIndex === 0) close(true);
  }

  function onBack() {
    if (stepIndex > 0) {
      stepIndex -= 1;
      renderStep();
    }
  }

  function tryOpenFromUrl() {
    var params = new URLSearchParams(global.location.search);
    if (params.get("open_prefs") !== "1") return;
    try {
      var raw = sessionStorage.getItem(SEARCH_CONTEXT_KEY);
      if (!raw) return;
      var ctx = JSON.parse(raw);
      var qs = searchQueryFromContext(ctx);
      if (!qs) return;
      openWizardWithRetry({ searchQuery: qs, summary: summaryFromQuery(qs) });
      params.delete("open_prefs");
      var nextQs = params.toString();
      var nextUrl = global.location.pathname + (nextQs ? "?" + nextQs : "") + global.location.hash;
      global.history.replaceState(null, "", nextUrl);
    } catch (e) {}
  }

  function ensureInit() {
    if (inited && wizardEl) return true;
    init();
    return !!wizardEl;
  }

  function init() {
    if (inited) return;
    wizardEl = document.getElementById("tfw-wizard");
    if (!wizardEl) return;
    if (wizardEl.parentElement !== document.body) {
      document.body.appendChild(wizardEl);
    }
    inited = true;

    summaryEl = document.getElementById("tfw-wizard-summary");
    titleEl = document.getElementById("tfw-wizard-title");
    progressEl = document.getElementById("tfw-wizard-progress");
    stepHost = document.getElementById("tfw-wizard-step-host");
    backBtn = wizardEl.querySelector("[data-tfw-back]");
    nextBtn = wizardEl.querySelector("[data-tfw-next]");
    skipBtn = wizardEl.querySelector("[data-tfw-skip]");
    closeBtns = wizardEl.querySelectorAll("[data-tfw-close]");

    if (nextBtn) nextBtn.addEventListener("click", onNext);
    if (backBtn) backBtn.addEventListener("click", onBack);
    if (skipBtn) {
      skipBtn.addEventListener("click", function () {
        finish(true);
      });
    }
    closeBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        close(true);
      });
    });

    document.addEventListener("keydown", function (e) {
      if (!wizardEl || wizardEl.hidden) return;
      onEscape(e);
      trapFocus(e);
    });

    tryOpenFromUrl();
  }

  global.SpecrTireWizard = {
    open: openWizardWithRetry,
    close: close,
    summaryFromQuery: summaryFromQuery,
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})(typeof window !== "undefined" ? window : this);
